import { render, staticRenderFns } from "./preventSwindle.vue?vue&type=template&id=b68d95d0&scoped=true&"
import script from "./preventSwindle.vue?vue&type=script&lang=js&"
export * from "./preventSwindle.vue?vue&type=script&lang=js&"
import style0 from "./preventSwindle.vue?vue&type=style&index=0&id=b68d95d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68d95d0",
  null
  
)

export default component.exports